import { NSAEmailVerificationPage, NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountRoutes } from "../AccountRoutes";

interface VerifyEmailPageProps extends NSARouterMakerResult, AccountRouterProps
{
	callback?: string;
}

function VerifyEmailPage(props: VerifyEmailPageProps) 
{
	return (
		<AccountLayout {...props} title={{ title: "Verification Code" }} >
			<NSAEmailVerificationPage
				{...props}
				callback={props.callback ?? AccountRoutes.UserProfile}
			/>
		</AccountLayout>
	);
};
export default VerifyEmailPage;